// Public surface of the patient-balances worklist (outreach PR 3).
//
// The registry imports the default (the page) and `patientBalancesIcon` for its one
// entry. Nothing else mounts anything from here: the campaign modal and the
// progress panel live inside the page.

import React from "react";

export { default } from "./PatientBalancesPage";
export { default as PatientBalancesPage } from "./PatientBalancesPage";

// The feature key on the capabilities gate. Rides collections, like the Outreach
// card; a key of its own is a later decision.
export const feature = "collections";

export const patientBalancesIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
    <path d="M18 2v4" />
    <path d="M16 4h4" />
  </svg>
);
